const GCLID_KEY = "htr_gclid";
const SOURCE_KEY = "htr_source";

export function captureGclid() {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const gclid = params.get("gclid");
  if (gclid) {
    localStorage.setItem(GCLID_KEY, gclid);
    localStorage.setItem(SOURCE_KEY, "Google Ads");
  }
  // Detect source
  if (!localStorage.getItem(SOURCE_KEY)) {
    const ref = document.referrer;
    if (ref.includes("google.com")) {
      localStorage.setItem(SOURCE_KEY, "Organic");
    } else if (ref) {
      localStorage.setItem(SOURCE_KEY, "Other");
    } else {
      localStorage.setItem(SOURCE_KEY, "Direct");
    }
  }
}

export function getGclid() {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(GCLID_KEY) || null;
}

export function getSource() {
  if (typeof window === "undefined") return "Direct";
  return localStorage.getItem(SOURCE_KEY) || "Direct";
}
